import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Heart } from 'lucide-react';
import { useTranslation } from '../i18n';
import VehicleCard from '../components/VehicleCard';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import SEOHead from '../components/SEOHead';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const FavoritesPage = ({ lang }) => {
  const { t } = useTranslation(lang);
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFavorites();
  }, []);

  const fetchFavorites = async () => {
    try {
      const response = await axios.get(`${API}/favorites`);
      setFavorites(response.data);
    } catch (error) {
      console.error('Error fetching favorites:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SEOHead 
        title="My Favorites | AAA of Miami"
        description="View your saved favorite vehicles at AAA of Miami"
      />
      <div className="pt-20 min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="mb-8">
          <h1 className="text-4xl font-bold mb-2 flex items-center" style={{ fontFamily: 'Playfair Display', color: 'var(--text-primary)' }} data-testid="favorites-title">
            <Heart className="w-10 h-10 mr-3 text-red-500 fill-red-500" />
            {t('nav.favorites')}
          </h1>
          <p className="text-gray-600 text-lg">{t('common.yourSavedVehicles')}</p>
        </div>

        {loading ? (
          <div className="flex justify-center items-center py-20">
            <div className="spinner"></div>
          </div>
        ) : favorites.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="favorites-grid">
            {favorites.map(vehicle => (
              <VehicleCard key={vehicle.id} vehicle={vehicle} lang={lang} />
            ))}
          </div>
        ) : (
          <div className="text-center py-20 bg-white rounded-lg">
            <Heart className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <p className="text-gray-500 text-lg mb-6">{t('favorites.noFavorites')}</p>
            <Link to="/inventory">
              <Button data-testid="browse-inventory-btn">{t('favorites.browseInventory')}</Button>
            </Link>
          </div>
        )}
      </div>
    </div>
    </>
  );
};

export default FavoritesPage;
